<template>
	<div>
		<!-- Table Container Card -->
		<b-card no-body>
			<div class="m-2">
				<!-- Table Top -->
				<b-row>
					<!-- Date picker -->
					<b-col cols="12" md="6">
						<b-row>
							<b-col md="5 p-0 mr-1">
								<label for="from-date">From Date</label>
								<b-form-datepicker
									id="from-date"
									:date-format-options="{
										year: 'numeric',
										month: 'short',
										day: '2-digit',
										weekday: 'short',
									}"
									placeholder="Choose a date"
									v-model="search_filter.from_date"
								/>
							</b-col>

							<b-col md="5 p-0">
								<label for="to-date">To Date</label>
								<b-form-datepicker
									id="to-date"
									:date-format-options="{
										year: 'numeric',
										month: 'short',
										day: '2-digit',
										weekday: 'short',
									}"
									placeholder="Choose a date"
									v-model="search_filter.to_date"
								/>
							</b-col>

							<b-col md="1 d-flex align-items-end">
								<b-button @click="getRawMaterialInventory()" variant="primary">Filter</b-button>
							</b-col>
						</b-row>
					</b-col>

					<!-- Search -->
					<b-col cols="12" md="6" class="mt-2 d-flex justify-content-end align-items-center">
						<div>
							<b-form-input
								type="text"
								class="form-control"
								placeholder="Search"
								@input="getRawMaterialInventory()"
								v-model.trim="search_filter.input_field"
								style="border-radius: 4px"
							/>
						</div>

						<b-button @click="clearFilter" variant="secondary ml-1">Clear</b-button>

						<b-button @click="excelDownload()" variant="warning" class="ml-1">
							<feather-icon icon="DownloadIcon" size="16" />
						</b-button>
					</b-col>
				</b-row>
			</div>

			<div v-if="rawMaterialInventory && rawMaterialInventory.total > 0">
				<b-table
					id="feed-stock"
					responsive
					:items="rawMaterialInventory.data"
					:fields="fields"
					show-empty
					empty-text="No matching records found"
				>
					<!-- Serial number -->
					<template #cell(index)="data">
						<div class="ml-1">
							{{ rawMaterialInventory.from + data.index }}
						</div>
					</template>

					<!-- Nested fields rendered via slots -->
					<template #cell(raw_material)="data">
						{{ data.item.raw_material ? data.item.raw_material.name : "NA" }}
					</template>

					<template #cell(unit)="data">
						{{ data.item.raw_material && data.item.raw_material.unit ? data.item.raw_material.unit.name : "NA" }}
					</template>

					<!-- Optional: show id with hash -->
					<template #cell(id)="data"> #{{ data.value }} </template>
				</b-table>
				<div class="d-flex justify-content-end mb-3 mt-2 mr-2">
					<b-button variant="primary">
						Total Raw Material Stock : {{ this.raw_material_stock ? this.raw_material_stock : 0 }}
					</b-button>
				</div>
				<div>
					<b-pagination
						:value="rawMaterialInventory.current_page"
						:total-rows="rawMaterialInventory.total"
						:per-page="rawMaterialInventory.per_page"
						align="right"
						@change="getRawMaterialInventory"
					/>
				</div>
			</div>

			<div v-else class="d-flex flex-column align-items-center py-5">
				<b-img :src="require('@/assets/images/svg/infographics/no_data_infographic.svg')" class="mr-2" />
				<h4 class="mt-2 Secondary">Raw Material stock is Empty</h4>
			</div>
		</b-card>
	</div>
</template>

<script>
import vSelect from "vue-select";
import axiosIns from "@/libs/axios";
import moment from "moment";

export default {
	components: { vSelect },
	data() {
		return {
			selected: null,
			searchQuery: null,
			search_filter: {
				input_field: "",
				to_date: "",
				from_date: "",
			},
			raw_material_stock: null,
			fields: [
				{ key: "index", label: "S.no" },
				{ key: "raw_material", label: "Raw Material" }, // via slot
				{ key: "unit", label: "Unit" }, // via slot
				{ key: "quantity", label: "Stock" },
				{
					key: "created_at",
					label: "Purchase Date",
					formatter: (value) => (value ? moment(value).format("MMMM Do YYYY") : "NA"),
				},
				{ key: "avg_cost", label: "Avg Cost" },
			],
			rawMaterialInventory: {},
			total_feed_count: null,
			userData: null,
		};
	},
	created() {
		this.userData = JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData") || "null");
		this.getRawMaterialInventory();
	},
	methods: {
		moment() {
			return moment();
		},

		getRawMaterialInventory(pageNo = 1) {
			const companyId = this.userData?.company?.id;
			const url = `web/company/${companyId}/raw-material-inventory`;

			const queryParams = { page: pageNo };
			if (this.search_filter.input_field) queryParams.input_field = this.search_filter.input_field;
			if (this.search_filter.to_date) queryParams.to_date = this.search_filter.to_date;
			if (this.search_filter.from_date) queryParams.from_date = this.search_filter.from_date;

			axiosIns
				.get(this.addQueryString(url, queryParams))
				.then((response) => {
					// ✅ match API shape shown in your screenshot
					this.rawMaterialInventory = response.data.rawMaterialInventory;
					this.raw_material_stock = response.data.total_raw_material;
				})
				.catch((error) => {
					console.error(error?.response?.data || error);
					this.$refs?.setErrors?.(error?.response?.data?.error);
				});
		},

		excelDownload() {
			// Build payload without mutating the visible filters
			const payload = { ...this.search_filter };
			if (payload.from_date && payload.to_date) {
				payload.from_date = moment(payload.from_date).format("YYYY-MM-DD");
				payload.to_date = moment(payload.to_date).format("YYYY-MM-DD");
			}

			const order_filter_data = this.prepareForm(payload);
			const companyId = this.userData?.company?.id;

			axiosIns
				.post(`web/company/${companyId}/export-raw-material-inventory`, order_filter_data)
				.then((response) => {
					const tempLink = document.createElement("a");
					tempLink.style.display = "none";
					tempLink.href = response.data.file;
					tempLink.setAttribute("download", response.data.name);
					if (typeof tempLink.download === "undefined") {
						tempLink.setAttribute("target", "_blank");
					}
					document.body.appendChild(tempLink);
					tempLink.click();
					document.body.removeChild(tempLink);

					// reset filters (optional)
					this.search_filter.to_date = null;
					this.search_filter.from_date = null;
					this.search_filter.input_field = null;

					this.getRawMaterialInventory(this.rawMaterialInventory?.current_page || 1);
				})
				.catch((error) => {
					const data = error?.response?.data?.errors;
					const arr = data ? Object.values(data).flat().toString(",") : "Export failed";
					this.$toast?.({
						component: () => import("@/@core/components/toastification/ToastificationContent.vue"),
						position: "top-right",
						props: { icon: "CoffeeIcon", variant: "danger", text: arr },
					});

					this.search_filter.to_date = null;
					this.search_filter.from_date = null;
					this.search_filter.input_field = null;

					this.getRawMaterialInventory(this.rawMaterialInventory?.current_page || 1);
				});
		},

		clearFilter() {
			this.search_filter.input_field = "";
			this.search_filter.to_date = "";
			this.search_filter.from_date = "";
			this.getRawMaterialInventory(1);
		},
	},
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>